<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section>
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column [xs]="12">
          <div class="registration-order-confirmation-page-title mb-5">
            <h1 class="mb-5">
              {{ vm.cmsData.registrationOrderConfirmationPageTitle }}
            </h1>
            <p class="mb-5">
              {{ vm.cmsData.registrationOrderConfirmationPageSubtitle }}
            </p>
          </div>
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>

    <dgx-components-grid-container *sharedSectionLoading="!vm.registrationCPG">
      <dgx-components-grid-row
        *ngIf="vm.registrationCPG && vm.showRegistrationCPG"
      >
        <dgx-components-grid-column
          [md]="6"
          [mdOrder]="1"
          [xs]="12"
          [xsOrder]="2"
        >
          <ng-container
            *ngFor="let registeredAppliance of vm.registeredAppliances"
          >
            <us-registration-confirmation-plan-details-panel
              *ngIf="vm.planDetails?.planNumber"
              [applianceTermsAndConditions]="
                vm.cmsData
                  .registrationOrderConfirmationPlanDetailsTermsAndConditions
              "
              [planDetails]="vm.planDetails"
              [planDetailsAnnualPrice]="vm.planDetails?.price"
              [registrationDetails]="registeredAppliance"
              [stacked]="vm.isMobile"
              class="d-block pb-3"
              variant="background-alternative"
            />

            <us-registration-confirmation-appliance-details-panel
              [registeredAppliance]="registeredAppliance"
              [registriaUserResponse]="vm.registriaUsersResponse"
              [stacked]="vm.isMobile"
              class="d-block pb-3"
              variant="background-alternative"
            />

            <us-registration-warranty-note-panel />
          </ng-container>
        </dgx-components-grid-column>

        <dgx-components-grid-column
          [md]="6"
          [mdOrder]="2"
          [xs]="12"
          [xsOrder]="1"
        >
          <us-registration-confirmation-cpg-panel
            *ngIf="vm.registrationCPG && vm.showRegistrationCPG"
            [applianceCPG]="vm.registrationCPG"
            class="d-block pb-3"
            variant="background-alternative"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>

      <dgx-components-grid-row *ngIf="!vm.showRegistrationCPG">
        <dgx-components-grid-column
          *ngFor="let registeredAppliance of vm.registeredAppliances"
          [md]="6"
          [xs]="12"
        >
          <us-registration-confirmation-plan-details-panel
            [applianceTermsAndConditions]="
              vm.cmsData
                .registrationOrderConfirmationPlanDetailsTermsAndConditions
            "
            [planDetails]="vm.planDetails"
            [planDetailsAnnualPrice]="vm.planDetails?.price"
            [registrationDetails]="registeredAppliance"
            [stacked]="vm.isMobile"
            class="d-block pb-3"
            variant="background-alternative"
          />
        </dgx-components-grid-column>

        <dgx-components-grid-column
          *ngFor="let registeredAppliance of vm.registeredAppliances"
          [md]="6"
          [xs]="12"
        >
          <us-registration-confirmation-appliance-details-panel
            [registeredAppliance]="registeredAppliance"
            [registriaUserResponse]="vm.registriaUsersResponse"
            [stacked]="vm.isMobile"
            class="d-block pb-3"
            variant="background-alternative"
          />

          <us-registration-warranty-note-panel />
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</ng-container>
